export default __webpack_public_path__ + "static/media/myinstructor.08fa039f.png";